module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/393.6507cc45.png";